import { Controller } from "@hotwired/stimulus"

// Promo wizard step 3 · période card.
// Provides 4 date presets + a live-updating duration badge.
//
//   <div data-controller="promo-period">
//     <input type="datetime-local" data-promo-period-target="startsAt">
//     <input type="datetime-local" data-promo-period-target="endsAt">
//     <div data-promo-period-target="duration">…</div>
//     <button data-action="click->promo-period#applyPreset" data-preset="today-7">+ 7j</button>
//   </div>
export default class extends Controller {
  static targets = ["startsAt", "endsAt", "duration"]

  connect() {
    this.startsAtTarget.addEventListener("change", () => this.#refreshDuration())
    this.endsAtTarget.addEventListener("change",   () => this.#refreshDuration())
  }

  applyPreset(event) {
    event.preventDefault()
    const preset = event.currentTarget.dataset.preset
    const now = new Date()
    const startOfDay = (d) => { const c = new Date(d); c.setHours(0, 0, 0, 0); return c }
    const endOfDay   = (d) => { const c = new Date(d); c.setHours(23, 59, 0, 0); return c }
    const addDays    = (d, n) => { const c = new Date(d); c.setDate(c.getDate() + n); return c }

    switch (preset) {
      case "today-7": {
        this.#setBoth(startOfDay(now), endOfDay(addDays(now, 7)))
        break
      }
      case "weekend": {
        // Saturday 00:00 → Sunday 23:59 of the upcoming weekend.
        const day = now.getDay() // 0=Sun, 6=Sat
        const daysUntilSat = (6 - day + 7) % 7
        const sat = startOfDay(addDays(now, daysUntilSat))
        const sun = endOfDay(addDays(sat, 1))
        this.#setBoth(sat, sun)
        break
      }
      case "month": {
        const first = startOfDay(new Date(now.getFullYear(), now.getMonth(), 1))
        const last  = endOfDay(new Date(now.getFullYear(), now.getMonth() + 1, 0))
        this.#setBoth(first, last)
        break
      }
      case "forever": {
        this.startsAtTarget.value = ""
        this.endsAtTarget.value   = ""
        this.#refreshDuration()
        break
      }
    }
  }

  #setBoth(start, end) {
    this.startsAtTarget.value = this.#toLocalInput(start)
    this.endsAtTarget.value   = this.#toLocalInput(end)
    this.#refreshDuration()
  }

  #toLocalInput(date) {
    // `<input type=datetime-local>` wants "YYYY-MM-DDTHH:MM" in local time.
    const pad = (n) => String(n).padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
           `T${pad(date.getHours())}:${pad(date.getMinutes())}`
  }

  #refreshDuration() {
    if (!this.hasDurationTarget) return
    const start = this.startsAtTarget.value ? new Date(this.startsAtTarget.value) : null
    const end   = this.endsAtTarget.value   ? new Date(this.endsAtTarget.value)   : null

    let label
    if (start && end) {
      const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24))
      label = days <= 0 ? "—" : `${days} jour${days > 1 ? "s" : ""}`
    } else if (start || end) {
      label = "Partielle"
    } else {
      label = "Permanent"
    }

    const value = this.durationTarget.querySelector(".promo-period__duration-value")
    if (value) value.textContent = label
  }
}
